.card {
    border: 1px solid #ccc;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    padding: 20px;
    background-color: #fff;
    /* Add any additional styles here */
  }
  
  
  /* Example of Card Title */
  .card h2 {
    font-size: 1.5rem;
    margin-top: 0;
  }
  
  /* Example of Card Content */
  .card p {
    margin-bottom: 0;
  }
  